module.exports = __webpack_public_path__ + "img/calendar-31.3d3a56bf.svg";